import React, { useCallback, useContext, useState, createContext } from "react";

import { Toast, ToastContainer } from "react-bootstrap";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);
  const showNotification = useCallback((message, variant = "info") => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, variant }]);

    setTimeout(() => {
      setToasts((prev) => {
        return prev.filter((obj) => obj.id !== id);
      });
    }, 3000);
  }, []);

  return (
    <ToastContext.Provider value={{ showNotification }}>
      {children}
      <ToastContainer
        position="top-end"
        className="p-3"
        style={{ zIndex: 1060 }}
      >
        {toasts.map((toast) => (
          <Toast key={toast.id} bg={toast.variant} show={true}>
            <Toast.Body className="text-white">{toast.message}</Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
    </ToastContext.Provider>
  );
};

export const useToastContext = () => useContext(ToastContext);
